
















































































































































import InvoiceSyncSettingForm from '@accounting/components/others/invoice-sync-setting-form/invoice-sync-setting-form.vue';
import {
  SaleDay,
  SaleDaySyncEvent,
} from '@modules/accounting-integrations/interfaces/pos-session-sync';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-sale-day-sync-modal',
  components: {
    'bpc-invoice-sync-setting-form': InvoiceSyncSettingForm,
  },
})
export default class SaleDaySyncModal extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly value: boolean;
  @Prop({ type: Object, required: true })
  readonly saleDay: SaleDay;
  @Prop({ type: String, required: true })
  readonly saleDayType: 'pos' | 'online';

  // DATA
  loadingAnalysis: boolean = true;
  analysis = null;
  analysisAccepted: boolean = false;
  showSyncReport: boolean = false;
  showSyncSettingForm: boolean = false;
  syncRequestCanBeSent: boolean = true;
  isSyncing: boolean = false;
  withErrors: boolean = false;
  errorReportPerPage: number = 5;
  errorReportCurrentPage: number = 1;
  successReportPerPage: number = 5;
  successReportCurrentPage: number = 1;
  errorSyncEvents: SaleDaySyncEvent[] = [];
  successSyncEvents: SaleDaySyncEvent[] = [];
  uxSessionCode: string = null;

  get showModal(): boolean {
    return this.value;
  }

  set showModal(val: boolean) {
    this.$emit('input', val);
  }

  // COMPUTED
  get errorReportRows() {
    return this.errorSyncEvents.length;
  }
  get errorReportCurrentList(): SaleDaySyncEvent[] {
    const start = (this.errorReportCurrentPage - 1) * this.errorReportPerPage;
    const end = start + this.errorReportPerPage;
    return this.errorSyncEvents.slice(start, end);
  }

  get successReportRows() {
    return this.successSyncEvents.length;
  }
  get successReportCurrentList(): SaleDaySyncEvent[] {
    const start = (this.successReportCurrentPage - 1) * this.successReportPerPage;
    const end = start + this.successReportPerPage;
    return this.successSyncEvents.slice(start, end);
  }

  mounted() {
    this.initialize();
  }

  destroyed() {
    if (this.uxSessionCode) {
      this.$bpcEcho.leaveSaleDaySyncChannel(this.uxSessionCode);
    }
  }
  // METHODS
  onCloseModal() {
    this.$emit('close-modal');
  }
  async onConfirmSync() {
    if (this.isSyncing || !this.syncRequestCanBeSent) {
      return;
    }
    if (this.uxSessionCode) {
      this.$bpcEcho.leaveSaleDaySyncChannel(this.uxSessionCode);
    }

    this.showSyncReport = true;
    this.isSyncing = true;
    this.errorSyncEvents = [];
    this.successSyncEvents = [];

    this.uxSessionCode = `sale-day-sync-${Date.now()}`;
    this.listenToWebsocketSaleDaySyncChannel();

    this.$emit('sync-started', this.saleDay);

    const url = this.$bpcApiRouteHelper.getApiPath(`sales-synchronization/${this.saleDayType}`);
    const body = {
      sessionCode: this.uxSessionCode,
      saleDayId: this.saleDay.id,
    };

    try {
      await this.$bpcApi.post(url, body).toPromise();
      this.$emit('sync-process-started', this.saleDay);
    } catch (error) {
      this.manageSyncError(error);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  manageSyncError(error: any) {
    const exceptionType = error?.response?.data?.exception;
    const message = error?.response?.data?.message;
    switch (exceptionType) {
      case 'BPC\\AccountingIntegrations\\Exceptions\\TenantNotReadyToSyncInvoicesException':
        this.$bpcMessage.showErrorMessage({ text: message });
        this.showSyncSettingForm = true;
        break;
      default:
        this.$bpcMessage.showErrorMessage({
          text: message ? message : 'global.invoices_to_sync_item.error',
        });
        break;
    }
    this.showSyncReport = false;
    this.syncRequestCanBeSent = true;
    this.isSyncing = false;
  }

  listenToWebsocketSaleDaySyncChannel() {
    this.$bpcEcho
      .getSaleDaySyncChannel(this.uxSessionCode)
      .listen('.BPC\\AccountingIntegrations\\Events\\SaleDaySyncBulkProcessed', data => {
        console.log('InvoiceSyncItemBulkProcessed', data);
        if (this.withErrors) {
          this.$bpcMessage.showErrorMessage({
            text: 'accounting_integrations.sale_day_sync_bulk_error_processing',
          });
        } else {
          this.$bpcMessage.showInfoMessage({
            text: 'accounting_integrations.sale_day_sync_bulk_processed',
          });
        }
        this.isSyncing = false;
        this.syncRequestCanBeSent = false;
        this.$emit('sync-process-finished', this.saleDay);
      })
      .listen('.BPC\\AccountingIntegrations\\Events\\SaleDaySyncBulkErrorProcessing', data => {
        console.log('SaleDaySyncBulkErrorProcessing', data);
        this.$bpcMessage.showErrorMessage({
          text: 'accounting_integrations.sale_day_sync_bulk_error_processing',
        });
        this.withErrors = true;
        this.isSyncing = false;
        this.syncRequestCanBeSent = false;
        this.$emit('sync-process-finished', this.saleDay);
      })
      .listen('.BPC\\AccountingIntegrations\\Events\\SaleDaySyncProcessed', data => {
        console.log('InvoiceSyncItemProcessed', data);
        this.successSyncEvents.push(data);
      })
      .listen('.BPC\\AccountingIntegrations\\Events\\SaleDaySyncErrorProcessing', data => {
        console.log('InvoiceSyncItemErrorProcessing', data);
        this.withErrors = true;
        this.errorSyncEvents.push(data);
      })
      .listen('.BPC\\AccountingIntegrations\\Events\\ExactConfigSaved', data => {
        console.log('ExactConfigSaved', data);
        this.$bpcMessage.showInfoMessage({
          text: 'global.invoice_sync_items.exact_config_saved',
        });
        this.showSyncSettingForm = false;
        this.syncRequestCanBeSent = true;
      });
  }

  initialize() {
    this.showSyncReport = false;
    this.isSyncing = false;
    this.withErrors = false;
    this.syncRequestCanBeSent = true;
    this.errorSyncEvents = [];
    this.successSyncEvents = [];
  }

  @Watch('showModal')
  onShowModal() {
    if (this.showModal) {
      this.initialize();
    }
  }
}
